<script>
import { VTimeline } from 'vuetify/lib'

export default {
  name: 'ETimeline',
  extends: VTimeline,
  props: {
    dense: {
      type: Boolean,
      default: true,
    },
    title: String,
  },
  computed: {
    classes() {
      return {
        'e-timeline': true,
        'v-timeline--align-top': this.alignTop,
        'v-timeline--dense': this.dense,
        'v-timeline--reverse': this.reverse,
        ...this.themeClasses,
      }
    },
  },
  render(h) {
    return h(
      'div',
      {
        staticClass: 'v-timeline',
        class: this.classes,
      },
      [this.title && h('div', { staticClass: 'e-timeline__title' }, this.title), this.$slots.default]
    )
  },
}
</script>
